"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@opensea/next-ui-kit";
import { Flex, FlexColumn, Separator, TextBody } from "@opensea/ui-kit";
import SeaRunner from "@/components/offline/SeaRunner";
import { ENVIRONMENT } from "@/constants/env";
import { useCaptureErrorOnMount } from "@/hooks/use-capture-error-on-mount";
import { getSentryIssueLink } from "@/lib/error";
import { getDatadogTraceLink } from "@/lib/graphql";
const SHOULD_RENDER_INTERNAL_LINKS = ENVIRONMENT !== "prod-mainnet";
export default function Error(t0) {
  const $ = _c(9);
  const {
    error
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      "error.severity": "oops"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== error) {
    t2 = {
      error,
      tags: t1,
      amplitudeEventName: "Error Page Impression"
    };
    $[1] = error;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    errorId,
    traceId
  } = useCaptureErrorOnMount(t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FlexColumn className="min-h-screen items-center justify-center gap-4 py-4"><SeaRunner /><Separator /></FlexColumn>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== errorId || $[5] !== traceId) {
    t4 = (errorId || traceId) && <div className="fixed right-4 bottom-4 space-y-2">{errorId && <Flex className="items-center gap-2"><TextBody color="warning" size="sm">Error ID: {errorId}</TextBody>{SHOULD_RENDER_INTERNAL_LINKS && <Button href={getSentryIssueLink(errorId)} size="sm" variant="secondary">Sentry</Button>}</Flex>}{traceId && <Flex className="items-center gap-2"><TextBody color="warning" size="sm">Trace ID: {traceId}</TextBody>{SHOULD_RENDER_INTERNAL_LINKS && <Button href={getDatadogTraceLink(traceId)} size="sm" variant="secondary">Datadog</Button>}</Flex>}</div>;
    $[4] = errorId;
    $[5] = traceId;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <main className="relative min-h-screen select-text">{t3}{t4}</main>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}